import React, { useState, useEffect, SetStateAction, Dispatch, ChangeEvent } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

interface ProductionLineFieldProps {
    action: "view" | "update" | "create",
    qir: any,
    setQir: Dispatch<SetStateAction<any>>,
    businessUnitDetails: any,
    onChange: (e:ChangeEvent<HTMLElement>) => void,
}

function ProductionLineField({ action, qir, setQir, businessUnitDetails, onChange }: ProductionLineFieldProps) {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const lineQueryParam = searchParams.get('line');
    const [selectedProductionLineId, setSelectedProductionLineId] = useState();
    const [tempProductionLine, setTempProductionLine] = useState<string>()
    // Set production line from query param 'line'
    // Or if productionLineId already exists on the QIR (e.g. update QIR)
    useEffect(() => {
        if (action === "create" && lineQueryParam && businessUnitDetails?.productionLines) {
            let selectedProductionLine = businessUnitDetails.productionLines.find((l: any) => l.name.toUpperCase() === lineQueryParam.toUpperCase());
            if (selectedProductionLine) {
                setSelectedProductionLineId(selectedProductionLine.id);
                setQir((q: any) => ({
                    ...q,
                    productionLineId: selectedProductionLine?.id
                }));
            }
        } else if (action === "create" && lineQueryParam && !businessUnitDetails?.productionLines) {
            setTempProductionLine(lineQueryParam);
        } else if (qir.productionLineId) {
            setSelectedProductionLineId(qir.productionLineId);
        } else {
            let productionLine = businessUnitDetails?.productionLines?.length === 1
                ? businessUnitDetails.productionLines[0]
                : undefined;
            setSelectedProductionLineId(productionLine?.id);
        }
    }, [action, lineQueryParam, businessUnitDetails?.productionLines, qir?.productionLineId, setQir]);

    return (
        <Form.Group as={Row} className="mb-1" controlId="productionLineId">
            <Form.Label column sm={3}>{t<string>('QIRDetail.Fields.ProductionLine')}</Form.Label>
            <Col sm={9}>
                {!businessUnitDetails
                    ? <Form.Control type="text" size="sm"
                        name="productionLineId"
                        value={qir?.productionLine || tempProductionLine}
                        readOnly />
                    : <Form.Select size="sm"
                        name="productionLineId"
                        value={selectedProductionLineId ?? ""}
                        onChange={onChange}
                        disabled={businessUnitDetails?.productionLines && businessUnitDetails.productionLines.length === 1}>
                        <>
                            <option key="0" value="">{t<string>('Application.Controls.DefaultSelect')}</option>
                            {
                                businessUnitDetails?.productionLines && businessUnitDetails.productionLines.map((line:any, i: number) => {
                                    return <option key={i + 1} value={line.id}>{line.display}</option>;
                                })
                            }
                        </>
                    </Form.Select>
                }
            </Col>
        </Form.Group>
    );
}

export default ProductionLineField;